import { database } from '../config';
import ErrorLog from './error';
const Error = new ErrorLog()

export default class ProductoCategoria {
    constructor() {
        this.Descripcion = ''
    }

    guardar(categoria) {
        // this.db.collection('post').doc('key').set({})
        return database.collection('productosCategoria').doc().set({
            ...categoria
        })
            .then()
            .catch(error => console.error(Error.guardarError(error)))
    }

    eliminar(id) {
        return new Promise((resolve, reject) => {
            database.collection("productosCategoria")
                .doc(id)
                .delete()
                .then(result => resolve(result))
                .catch(error => reject(Error.guardarError(error)))
        })
    }


    getCategorias() {
        return new Promise((resolve, reject)=>{
            database.collection('productosCategoria')
            .get()
            .then(querySnapshot => resolve(querySnapshot.docs))
            .catch(error => reject(Error.guardarError(error)))
        })
    }

}